import {
  PrerequisiteProps,
  PrerequisitesTooltip,
} from '../PrerequisitesTooltip/PrerequisitesTooltip';

type ActionsMenuPrerequisitesTooltipProps = {
  title?: string;
  isInEnrollmentsDatatable?: boolean;
  isAllEqual: boolean;
  prerequisites: PrerequisiteProps[];
  children: React.ReactNode;
};

export const ActionsMenuPrerequisitesTooltip = ({
  title = 'Action',
  isInEnrollmentsDatatable = false,
  isAllEqual,
  prerequisites,
  children,
}: ActionsMenuPrerequisitesTooltipProps) => {
  return (
    <PrerequisitesTooltip
      title={title}
      withTooltip={!isInEnrollmentsDatatable || isAllEqual}
      prerequisites={prerequisites}
    >
      {children}
    </PrerequisitesTooltip>
  );
};
